export enum BreakdownType {
  REGION = 'REGION',
  AREA = 'AREA_COUNT'
}

export enum PropertyQueryKey {
  GET_PROPERTY_BASIC_INFO = 'GET_PROPERTY_BASIC_INFO',
  GET_PROPERTIES = 'GET_PROPERTIES'
}
